import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { RewardsModalInterface } from '../models';

@Component({
  selector: 'nx-ng-rewards-modal',
  templateUrl: './rewards-modal.component.html',
  styleUrls: ['./rewards-modal.component.scss'],
})
export class RewardsModalComponent implements OnInit {
  bookingMessage = '';

  constructor(
    public dialogRef: MatDialogRef<RewardsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RewardsModalInterface,
    @Inject(I18NEXT_SERVICE) private i18n: ITranslationService
  ) {}

  ngOnInit(): void {
    this.bookingMessage = this.i18n.t('rewards_booking_complete');
  }
}
